const faqData = {
  faqs: [
    {
      question: "How much does delivery cost?",
      answer:
        "Delivery is free within the city limits. Additional fees apply for deliveries outside the city.",
    },
    {
      question: "How do I return an item?",
      answer:
        "You can initiate a return by going to your order details and selecting the 'Request Return' option.",
    },
    {
      question: "Can I change my delivery address after placing an order?",
      answer:
        "Yes, contact our support team within 24 hours of placing your order to update the delivery address.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept credit/debit cards, PayPal, and cash on delivery.",
    },
    {
      question: "How do I track my order?",
      answer:
        "You can track your order using the tracking number provided in your confirmation email.",
    },
    {
      question: "Can I cancel my order?",
      answer:
        "Orders can be canceled within the first 2 hours after placement. Contact our support team for assistance.",
    },
  ],
  termsOfService: `
      By using MobilePlus.com, you agree to our Terms of Service. 
      All purchases are subject to availability and must comply with local regulations. 
      Unauthorized reselling of our products is prohibited. 
      We reserve the right to update these terms at any time.
    `,
  shippingAndReturns: `
      At MobilePlus.com, we offer free shipping within the city limits. 
      For areas outside the city, a shipping fee will apply based on the location. 
      Products can be returned within 14 days of purchase, provided they are unused and in their original packaging. 
      Please contact our support team to initiate a return or exchange.
    `,
  privacyPolicy: `
      ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ

Настоящая Политика конфиденциальности персональных данных (далее – Политика конфиденциальности) действует в отношении всей информации, которую Интернет-магазин «Mobil+»,расположенный на доменном имени “mobileplus.store”, может получить о Пользователе во время использования сайта Интернет-магазина «Mobil+».

ОПРЕДЕЛЕНИЕ ТЕРМИНОВ

1.1. В настоящей Политике конфиденциальности используются следующие термины:

1.1.1. «Администрация сайта Интернет-магазина «mobileplus.store» (далее – Администрация сайта) – уполномоченные сотрудники на управление сайтом, действующие от имени Интернет-магазина «mobileplus.store”, которые организуют и (или) осуществляют обработку персональных данных, а также определяют цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.

1.1.2. «Персональные данные» - сведения, относящиеся к определенному или определяемому на их основании субъекту персональных данных, зафиксированные на электронном, бумажном и (или) ином материальном носителе.

1.1.3. «Обработка персональных данных» - действия, направленные на накопление, хранение, изменение, дополнение, использование, распространение, обезличивание, блокирование и уничтожение персональных данных.

1.1.4. «Защита персональных данных» - комплекс мер, в том числе правовых, организационных и технических, осуществляемых в целях, установленных Законом РК «О персональных данных и их защите».

1.1.5. «Пользователь сайта Интернет-магазина «mobileplus.store» (далее - Пользователь) – физическое лицо, имеющее доступ к Сайту, посредством сети Интернет и использующее Сайт интернет-магазина «mobileplus.store».

1.1.6. «Cookies» — небольшой фрагмент данных, отправленный веб-сервером и хранимый на компьютере пользователя, который веб-клиент или веб-браузер каждый раз пересылает веб-серверу в HTTP-запросе при попытке открыть страницу соответствующего сайта.

1.1.7. «IP-адрес» — уникальный сетевой адрес узла в компьютерной сети, построенной по протоколу IP.

ОБЩИЕ ПОЛОЖЕНИЯ

2.1. Использование Пользователем сайта Интернет-магазина «mobileplus.store» означает согласие с настоящей Политикой конфиденциальности и условиями обработки персональных данных Пользователя.

2.2. В случае несогласия с условиями Политики конфиденциальности Пользователь должен прекратить использование сайта Интернет-магазина «mobileplus.store».

2.3. Настоящая Политика конфиденциальности применяется к сайту Интернет-магазина «mobileplus.store». Интернет-магазин «mobileplus.store» не контролирует и не несет ответственность за сайты третьих лиц, на которые Пользователь может перейти по ссылкам, доступным на сайте Интернет-магазина «mobileplus.store».

2.4. Администрация сайта не проверяет достоверность персональных данных, предоставляемых Пользователем сайта Интернет-магазина «mobileplus.store».

ПРЕДМЕТ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ

3.1. Настоящая Политика конфиденциальности устанавливает обязательства Администрации сайта интернет-магазина «mobileplus.store» по неразглашению и обеспечению режима защиты конфиденциальности персональных данных, которые Пользователь предоставляет по запросу Администрации сайта при регистрации на сайте Интернет-магазина «mobileplus.store» или при оформлении заказа для приобретения Товара.

3.2. Персональные данные, разрешённые к обработке в рамках настоящей Политики конфиденциальности, предоставляются Пользователем путём заполнения регистрационной формы на сайте Интернет-магазина «mobileplus.store».

3.3. Любая иная персональная информация неоговоренная выше (история покупок, используемые браузеры и операционные системы и т.д.) подлежит надежному хранению и нераспространению, за исключением случаев, предусмотренных в п.п. 5.2. и 5.3. настоящей Политики конфиденциальности.

ЦЕЛИ СБОРА ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ

4.1. Персональные данные Пользователя Администрация сайта интернет-магазина «mobileplus.store» может использовать в целях:

4.1.1. Идентификации Пользователя, зарегистрированного на сайте Интернет-магазина «mobileplus.store», для оформления заказа и (или) заключения Договора купли-продажи товара дистанционным способом.

4.1.2. Предоставления Пользователю доступа к персонализированным ресурсам сайта Интернет-магазина «mobileplus.store».

4.1.3. Установления с Пользователем обратной связи, включая направление уведомлений, запросов, касающихся использования сайта Интернет-магазина «mobileplus.store», оказания услуг, обработка запросов и заявок от Пользователя.

4.1.4. Подтверждения достоверности и полноты персональных данных, предоставленных Пользователем.

4.1.5. Создания учетной записи для совершения покупок.

4.1.6. Уведомления Пользователя сайта Интернет-магазина «mobileplus.store» о состоянии заказа.

4.1.7. Обработки и получения платежей, оспаривания платежа.

4.1.8. Предоставления Пользователю эффективной клиентской и технической поддержки при возникновении проблем, связанных с использованием сайта Интернет-магазина «mobileplus.store».

4.1.9. Предоставления Пользователю специальных предложений, информации о ценах, проводимых и предстоящих акциях, новостной рассылки и иных сведений от имени Интернет-магазина «mobileplus.store».

4.1.10 Осуществления рекламной деятельности.

4.1.11. Предоставления доступа Пользователю на сайты.

4.2. Пользователь вправе отказаться от получения рассылки в любое время, направив соответствующее письмо по адресу или электронному адресу, указанному в п.9.3 и п 9.4 настоящей Политике о конфиденциальности.

СПОСОБЫ И СРОКИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ

5.1. Обработка персональных данных Пользователя осуществляется без ограничения срока, любым законным способом, в том числе в информационных системах персональных данных с использованием средств автоматизации или без использования таких средств.

5.2. Пользователь соглашается с тем, что Администрация сайта вправе передавать персональные данные третьим лицам, в частности, курьерским службам, организациями почтовой связи, операторам электросвязи, исключительно в целях выполнения заказа Пользователя, оформленного на сайте Интернет-магазина «mobileplus.store», включая доставку товара.

5.3. Персональные данные Пользователя могут быть переданы уполномоченным органам государственной власти Республики Казахстан по основаниям и в порядке, установленным законодательством Республики Казахстан.

5.4. Администрация сайта принимает необходимые организационные и технические меры для защиты персональной информации Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий третьих лиц.

5.5. Администрация сайта совместно с Пользователем принимает все необходимые меры по предотвращению убытков или иных отрицательных последствий, вызванных утратой или разглашением персональных данных Пользователя.

ОБЯЗАТЕЛЬСТВА СТОРОН

6.1. Пользователь обязан:

6.1.1. Для регистрации на сайте интернет магазина «mobileplus.store» необходимо предоставление клиентом персональных данных.

6.1.2. Обновить, дополнить предоставленную информацию о персональных данных в случае изменения данной информации.

6.2. Администрация сайта обязана:

6.2.1. Использовать полученную информацию исключительно для целей, указанных в п. 4 настоящей Политики конфиденциальности.

6.2.2. Обеспечить хранение конфиденциальной информации в тайне, не разглашать без предварительного письменного разрешения Пользователя, а также не осуществлять продажу, обмен, либо разглашение иными возможными способами переданных персональных данных Пользователя, за исключением п.п. 5.2. и 5.3. настоящей Политики Конфиденциальности.

6.2.3. Принимать меры предосторожности для защиты конфиденциальности персональных данных Пользователя согласно порядку, обычно используемого для защиты такого рода информации в существующем деловом обороте.

6.2.4. Осуществить блокирование персональных данных, относящихся к соответствующему Пользователю, с момента обращения или запроса Пользователя, или его законного представителя либо уполномоченного органа по защите прав субъектов персональных данных на период проверки, в случае выявления недостоверных персональных данных или неправомерных действий.

ОТВЕТСТВЕННОСТЬ СТОРОН

7.1. В случае утраты или разглашения конфиденциальной информации Администрация сайта не несёт ответственность, если данная конфиденциальная информация:

7.1.1. Стала публичным достоянием до её утраты или разглашения.

7.1.2. Была получена от третьей стороны до момента её получения Администрацией сайта от Пользователя.

7.1.3. Была разглашена с согласия Пользователя.

РАЗРЕШЕНИЕ СПОРОВ

8.1. До обращения в суд с иском по спорам, возникающим из отношений между Пользователем сайта Интернет-магазина «mobileplus.store» и Администрацией сайта обязательным является предъявление претензии (письменного предложения о добровольном урегулировании спора).

8.2. Получатель претензии в течение 30 календарных дней со дня получения претензии, письменно уведомляет заявителя претензии о результатах рассмотрения претензии.

8.3. При недостижении соглашения спор будет передан на рассмотрение в судебный орган в соответствии с действующим законодательством Республики Казахстан.

8.4. К настоящей Политике конфиденциальности и отношениям между Пользователем и Администрацией сайта применяется действующее законодательство Республики Казахстан.

ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ

9.1. Администрация сайта вправе вносить изменения в настоящую Политику конфиденциальности без согласия Пользователя.

9.2. Новая Политика конфиденциальности вступает в силу с момента ее размещения на сайте Интернет-магазина «mobileplus.store», если иное не предусмотрено новой редакцией Политики конфиденциальности.

9.3. Все предложения или вопросы по настоящей Политике конфиденциальности следует сообщать на электронный адрес mobileplus.store 180103127@stu.sdu.edu.kz сайта Интернет-магазина «mobileplus.store».

9.4. Адрес магазина «mobileplus.store»: город Алматы, Алатауский район, ул. Алтынсарина, 108А
    `,
  about: `
      Welcome to mobileplus.store! 
      We specialize in providing the latest smartphones at competitive prices. 
      With a commitment to quality and customer satisfaction, our team is here to help you find the perfect device for your needs. 
      Explore our range of products and experience seamless shopping today!
    `,
};

export default faqData;
